import FormSwiftAPIClient from '../FormSwiftAPIClient';
import { EventActionTypeEnum } from './EventConstants';

export const formSwiftAPIClient = new FormSwiftAPIClient(window.API_URL);

const createEventRequest = eventType => (
  (dispatch) => {
    dispatch({ type: EventActionTypeEnum.CREATE_EVENT_REQUEST, eventType });
  }
);

export const createEvent = (eventType, eventData, userId = undefined) => (
  async (dispatch) => {
    dispatch(createEventRequest(eventType, eventData));
    const sendData = {
      share_key: window.DocumentSettings.shareKey,
      session_id: window.DocumentSettings.key,
      session_hash: window.DocumentSettings.ses,
      event_type: eventType,
      event_data: eventData,
    };
    if (userId) {
      sendData.owner_user_id = userId;
    }
    try {
      const res = await formSwiftAPIClient.request('POST', '/event', sendData);
      dispatch({
        type: EventActionTypeEnum.CREATE_EVENT_SUCCESS,
        response: res.data,
        eventType,
      });
    } catch (e) {
      dispatch({
        type: EventActionTypeEnum.CREATE_EVENT_FAILURE,
        error: e.message,
      });
    }
  }
);

export const createEventForDocumentShare = (shareKey, eventType) => (
  async (dispatch) => {
    dispatch(createEventRequest(eventType, {}));
    try {
      const res = await formSwiftAPIClient.request('POST', `/document-share/${shareKey}/event`, { event_type: eventType });
      dispatch({
        type: EventActionTypeEnum.CREATE_EVENT_SUCCESS,
        response: res.data,
        eventType,
      });
    } catch (e) {
      dispatch({
        type: EventActionTypeEnum.CREATE_EVENT_FAILURE,
        error: e.message,
      });
    }
  }
);



// WEBPACK FOOTER //
// ./src-react/FormSwiftAPI/Event/EventActions.jsx